import React from 'react';
import { Clock, CreditCard, MapPin, Phone } from 'lucide-react';

const TrustBadges = () => {
  return (
    <section className="py-12 bg-gray-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-black text-gray-900 mb-4">
            Why Sacramento Families Trust Sailors Bail Bonds
          </h2>
        </div>

        <div className="grid lg:grid-cols-4 gap-6">
          {/* Local & Near Jail */}
          <div className="text-center p-6 bg-white rounded-xl shadow-lg">
            <MapPin className="w-12 h-12 text-blue-600 mx-auto mb-4" />
            <h3 className="text-lg font-bold text-gray-900 mb-2">Local & Near Jail</h3>
            <p className="text-gray-600 text-sm">Real office with real agents near courthouse</p>
          </div>

          {/* Payment by Phone */}
          <div className="text-center p-6 bg-white rounded-xl shadow-lg">
            <Phone className="w-12 h-12 text-purple-600 mx-auto mb-4" />
            <h3 className="text-lg font-bold text-gray-900 mb-2">Payment by Phone</h3>
            <p className="text-gray-600 text-sm">No office visit required - handle everything remotely</p>
          </div>

          {/* 0% Down & Payment Plans */}
          <div className="text-center p-6 bg-white rounded-xl shadow-lg">
            <CreditCard className="w-12 h-12 text-yellow-600 mx-auto mb-4" />
            <h3 className="text-lg font-bold text-gray-900 mb-2">0% Down OAC</h3>
            <p className="text-gray-600 text-sm">Flexible payment plans to fit any budget</p>
          </div>

          {/* Fast Processing */}
          <div className="text-center p-6 bg-white rounded-xl shadow-lg">
            <Clock className="w-12 h-12 text-red-600 mx-auto mb-4" />
            <h3 className="text-lg font-bold text-gray-900 mb-2">10-15 Min Paperwork</h3>
            <p className="text-gray-600 text-sm">We coordinate release immediately after signing</p>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="mt-12 text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-6">We Accept All Major Payment Methods</h3>
          <div className="flex flex-wrap justify-center items-center gap-6">
            <div className="px-4 py-2 bg-white rounded-lg shadow border">
              <span className="font-semibold text-gray-700">💳 Credit Cards</span>
            </div>
            <div className="px-4 py-2 bg-white rounded-lg shadow border">
              <span className="font-semibold text-gray-700">💰 Debit Cards</span>
            </div>
            <div className="px-4 py-2 bg-white rounded-lg shadow border">
              <span className="font-semibold text-gray-700">🏦 Bank Transfer</span>
            </div>
            <div className="px-4 py-2 bg-white rounded-lg shadow border">
              <span className="font-semibold text-gray-700">📱 Payment Plans</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;